import { getInputs } from "./getFormValues";
import { useParams } from "react-router-dom";
import { useEffect } from "react";
import { Container, CardBody } from "reactstrap";
import '../global/GlobalCSS.css';
import TableRecord from "./GenericTable/TableRecord";
import { InputProps } from "./Form.Interface"
import { getRecordsAction, setRecordState, setRecordId } from "../Store/Generic/GenericSlice";
import { useDispatch, useSelector } from "react-redux";
import AddEditModel from "./AddEdit.model";
import ViewModel from "./View.model";
import DeleteModel from "./Delete.model";

const GenericDynamic = () => {
    const { masters } = useParams();
    let { inputs } = getInputs(masters);
    const dispatch = useDispatch();
    // function to filter coluns out of inputProps array
    const columns = (inputs: Array<InputProps>) => {
        const filteredAndSorted = inputs
            .filter((item) => item.table_columns === true)
            .sort((a: InputProps, b: InputProps) => (a.table_columns_sequence ?? 0) - (b.table_columns_sequence ?? 0));

        const returnObject = filteredAndSorted.map((table) => ({
            name: table.name,
            label: table.label ?? '',
        }));

        return returnObject;
    };

    const { records } = useSelector(
        (state: any) => state.Generic
    );

    useEffect(() => {
        dispatch(getRecordsAction(masters as string));
    }, [dispatch, masters]);

    return (
        <>
            <Container fluid>
                <div className="ele_row">
                    {
                        inputs.map(({ name, type, value, ...props },index: number) => {
                            return <h4 key={index}>{props.page_title}</h4>
                        })
                    }
                    <button
                        type="button"
                        className="btn btn-primary waves-effect waves-light mb-3 grp_justify_right"
                        data-toggle="modal"
                        data-target=".bs-example-modal-xl"
                        onClick={() => {
                            dispatch(setRecordState('NEW'));
                            dispatch(setRecordId(-1));
                        }}
                    >
                        <i className="dripicons-plus font-size-16 align-middle me-2"></i>
                        Add New
                    </button>
                    <AddEditModel key="add1" />
                    <ViewModel key="view1" />
                    <DeleteModel key="delete1" />
                </div>
                <CardBody>
                    <div className="table-responsive">
                        <TableRecord key="records-1" data={records} columns={columns(inputs)} />
                    </div>
                </CardBody>
            </Container >
        </>
    )
}

export default GenericDynamic;